import { fade } from '@material-ui/core/styles/colorManipulator';
import { lighten } from '@material-ui/core/styles/colorManipulator';
export const styles = theme => ({
    tableWrapper: {
        width: '100%',
        overflowX: 'auto',
        minHeight: 300
    },
    notiTable: {
        width: '100%',
        paddingTop: theme.spacing(2),
        // paddingBottom: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        boxSizing: 'border-box'
    },
    tableContainer: {
        width: '100%',
    },
    frameTitle: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    paperRoot: {
        // paddingTop: theme.spacing(2),
        // paddingBottom: theme.spacing(2),
        // paddingLeft: theme.spacing(2),
        // paddingRight: theme.spacing(2),
        marginTop: theme.spacing(2),
        // width: 'fit-content',
        width: '100%'
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    iconEdit: {
        width: '16px',
        height: '16px',
        cursor: 'pointer',
    },
    icon: {
        fontSize: 40,
        float: 'right',
        cursor: 'pointer'
    },
    iconWrap: {
        fontSize: 40,
        float: 'right',
        cursor: 'pointer',
        padding: '4px'
    },
    tableCellInCollapes: {
        borderBottom: 'none'
    },
});



export const toolbarStyles = theme => ({
    root: {
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    spacer: {
        flex: '1 1 100%',
    },
    actions: {
        color: theme.palette.text.secondary,
    },
    title: {
        flex: '0 0 auto',

    },
    subTitle: {
        fontSize: '1.5rem',

    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: '20%',
        float: 'right'
    },
    icon: {
        marginTop: theme.spacing(3),
        width: 36,
        height: 36,
        left: -8
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade('#9E9E9E', 0.15),
        '&:hover': {
            backgroundColor: fade('#9E9E9E', 0.25),
        },
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(3),
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing(9),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        paddingTop: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(10),
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: 120,
            '&:focus': {
                width: 200,
            },
        },
    },
});